import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Divider,
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  Button,
  InputLabel
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import config from "../../../config.js";


const UserForm = ({onAddUser,value}) => {

    const [user_id, setuser_id] = useState("");
    const [username, setusername] = useState("");
    const [emailid, setemailid] = useState("");
    const [phonenum, setphonenum] = useState("");
    const [department, setdepartment] = useState("");
    const [complaintType, setcomplaintType] = useState("");
    const [complaintTypes, setcomplaintTypes] = useState([]);
    const [subcomplaintType, setsubcomplaintType] = useState([]);
    const [departments, setdepartments] = useState([]);
    const [designation, setdesignation] = useState("");
    const [password, setpass] = useState("");
    const userId = localStorage.getItem('userId');

  const navigate = useNavigate();

  // Function to handle the click event
  // const handleAddUser = () => {
  //   navigate('/dashboard-Admin'); // Replace with your target path
  // };

  const getdepartments = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/getdepartments`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setdepartments(jsonData);
    } catch (err) {
      console.error(err.message)
    } 
  }

  const getcomplaintTypes = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/get_all_complaint_types`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setcomplaintTypes(jsonData);
    } catch (err) {
      console.error(err.message)
    } 
  }

  const onSubmitform = async (e) => {
    e.preventDefault();
    if(value==1){
    try {
      const body = {user_id, username, emailid, phonenum, department,designation, password };
     
      const response = await fetch(`${config.BASE_URL_IP}/wob/new-user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      console.log(response);
      window.alert("Complaint submitted successfully!");
      setuser_id(" ");
      setdepartment(" ");
      setdesignation(" ");
      setemailid(" ");
      setpass(" ");
      setphonenum(" ");
      setusername(" ");
    // handleAddUser();
      onAddUser();
    } catch (err) {
      console.error(err.message);
    }
  }
  if(value==2){
    try {
      const body = { complaintType,department};
     
      const response = await fetch(`${config.BASE_URL_IP}/wob/new-complaintType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      console.log(response);
      window.alert("Complaint submitted successfully!");
      setdepartment(" ");
      setcomplaintType(" ");
    // handleAddUser();
      onAddUser();
    } catch (err) {
      console.error(err.message);
    }
  }
  if(value==3){
    try {
      const body = { complaintType,subcomplaintType};
     
      const response = await fetch(`${config.BASE_URL_IP}/wob/new-sub-complaintType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      console.log(response);
      window.alert("Complaint submitted successfully!");
      setcomplaintType(" ");
      setsubcomplaintType(" ");
    // handleAddUser();
      onAddUser();
    } catch (err) {
      console.error(err.message);
    }
  }
  if(value==4){
    try {
      const body = { department};
     
      const response = await fetch(`${config.BASE_URL_IP}/wob/new-department`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      console.log(response);
      window.alert("Complaint submitted successfully!");
      setdepartment(" ");
    // handleAddUser();
      onAddUser();
    } catch (err) {
      console.error(err.message);
    }
  }
  };

  // const handleComplaintTypeChange = (event) => {
  //   setuser(event.target.value);
  //   setSubComplaintType("");
  //   setSubSubComplaintType("");
  //   setShowSubSubComplaintType(false);
  // };
  
  const handleMouseOver = (event) => {
    event.target.style.backgroundColor = "#09B3CE";
  };

  const handleMouseOut = (event) => {
    event.target.style.backgroundColor = "#15D2F0";
  };

  const handleMouseDown = (event) => {
    event.target.style.backgroundColor = "#3e8e41";
  };

  const handleMouseUp = (event) => {
    event.target.style.backgroundColor = "#09B3CE";
  };
  
  useEffect(()=>{
    getdepartments();
    getcomplaintTypes();
  },[])

  return (
    <div>
      <Card variant="outlined">
        <Box sx={{ padding: "15px 30px" }}>
        <Button
        startIcon={<ArrowBackIcon />}
        onClick={onAddUser}
        variant="contained"
        sx={{ mb: 2 }}
      >
        Back
      </Button>
          <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
            New User
          </Typography>
        </Box>
        <Divider />
        <CardContent sx={{ padding: "30px" }}>
          <form onSubmit={onSubmitform}>
            <div>
              {/* <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                label="ComplaintType"
                value={username}
                onChange={(e) => setuser(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              >
                <MenuItem value="Complaint Type" disabled defaultChecked>
                  <em>Complaint Type</em>
                </MenuItem>
                {Object.values(ComplaintTypes).map((complaintType) => (
                  <MenuItem key={complaintType} value={complaintType}>
                    {complaintType}
                  </MenuItem>
                ))}
              </Select> */}
              {/* {username !== "" && (
                <>
                  <InputLabel id="sub-complaint-type-label">
                    {username === ComplaintTypes.EOelectrical || username === ComplaintTypes.EOcivil
                      ? "Sub Category"
                      : "Sub Complaint Type"}
                  </InputLabel>
                  <Select
                    labelId="sub-complaint-type-label"
                    id="sub-complaint-type"
                    label="SubComplaintType"
                    value={subComplaintType}
                    onChange={handleSubComplaintTypeChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="" disabled>
                      Select {username === ComplaintTypes.EOelectrical || username === ComplaintTypes.EOcivil
                      ? "Sub Category"
                      : "Sub Complaint Type"}
                    </MenuItem>
                    {getSubComplaintTypes(username).map((subType) => (
                      <MenuItem key={subType} value={subType}>
                        {subType}
                      </MenuItem>
                    ))}
                  </Select>
                  {showSubSubComplaintType && (
                  <>
                    <InputLabel id="sub-sub-complaint-type-label">
                      {username === ComplaintTypes.EOelectrical || username === ComplaintTypes.EOcivil
                        ? "Sub Complaint Type"
                        : "Sub-sub Complaint Type"}
                    </InputLabel>
                    <Select
                      labelId="sub-sub-complaint-type-label"
                      id="sub-sub-complaint-type"
                      label="SubSubComplaintType"
                      value={subSubComplaintType}
                      onChange={(e) => handleSubSubComplaintTypeChange(e)}
                      fullWidth
                      sx={{ mb: 2 }}
                    >
                      <MenuItem value="" disabled>
                        Select {username === ComplaintTypes.EOelectrical || username === ComplaintTypes.EOcivil
                        ? "Sub Complaint Type"
                        : "Sub-sub Complaint Type"}
                      </MenuItem>
                      {getSubSubComplaintTypes(subComplaintType).map((subSubType) => (
                        <MenuItem key={subSubType} value={subSubType}>
                          {subSubType}
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                )}
                </>
              )} */}
            </div>
            { value===1 && (
            <>
            <InputLabel id="userid">User ID</InputLabel>
              <TextField
                labelId="userid"
                id="outlined-multiline-static"
                multiline
                variant="outlined"
                value={user_id}
                onChange={(e) => setuser_id(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              />
  
              <InputLabel id="Username">Username</InputLabel>
              <TextField
                labelId="Username"
                id="outlined-multiline-static"
                multiline
                variant="outlined"
                value={username}
                onChange={(e) => setusername(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              />
  
              <InputLabel id="emailid">Email ID</InputLabel>
  
              <TextField
                labelId="emailid"
                id="outlined-multiline-static"
                multiline
                variant="outlined"
                placeholder="Sai - 1234567890"
                value={emailid}
                onChange={(e) => setemailid(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              />
  
              <InputLabel id="phonenum">Phone Number</InputLabel>
  
              <TextField
              labelId="phonenum"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Sai - 1234567890"
              value={phonenum}
              onChange={(e) => setphonenum(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
                <InputLabel id="demo-simple-select-standard-label">
                Department
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="WorkOrderType"
                  value={department}
                  onChange={(e) => setdepartment(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="Work-Order Type" disabled defaultChecked>
                    <em>Department</em>
                  </MenuItem>
                  {departments.map((dept) => (
                    <MenuItem key={dept.department_id} value={dept.department_id}>
                      {dept.department}
                    </MenuItem>
                  ))}
                </Select>
  
              <InputLabel id="designation">Designation</InputLabel>
  
              <TextField
              labelId="designation"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Sai - 1234567890"
              value={designation}
              onChange={(e) => setdesignation(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
  
              <InputLabel id="password">Password</InputLabel>
  
              <TextField
              labelId="password"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Sai - 1234567890"
              value={password}
              onChange={(e) => setpass(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
            </>)
            }
            { value==2 && (
            <>
            <InputLabel id="complaint_type">
                Complaint Type
                </InputLabel>
                <TextField
              labelId="complaint_type"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Enter complaint type"
              value={complaintType}
              onChange={(e) => setcomplaintType(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
              <InputLabel id="demo-simple-select-standard-label">
                Department
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="WorkOrderType"
                  value={department}
                  onChange={(e) => setdepartment(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="Work-Order Type" disabled defaultChecked>
                    <em>Department</em>
                  </MenuItem>
                  {departments.map((dept) => (
                    <MenuItem key={dept.department_id} value={dept.department_id}>
                      {dept.department}
                    </MenuItem>
                  ))}
                </Select>
            </>
          )}
          { value==3 && (
            <>
              <InputLabel id="demo-simple-select-standard-label">
                Complaint Types
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="WorkOrderType"
                  value={complaintType}
                  onChange={(e) => setcomplaintType(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="Work-Order Type" disabled defaultChecked>
                    <em>Complaint Types</em>
                  </MenuItem>
                  {complaintTypes.map((ct) => (
                    <MenuItem key={ct.complaint_type_id} value={ct.complaint_type_id}>
                      {ct.complaint_type}
                    </MenuItem>
                  ))}
                </Select>
                <InputLabel id="sub_complaint_type">
                Sub Complaint Type
                </InputLabel>
                <TextField
              labelId="sub_complaint_type"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Enter Sub complaint type"
              value={subcomplaintType}
              onChange={(e) => setsubcomplaintType(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
            </>
          )}
          { value==4 && (
            <>
              <InputLabel id="complaint_type">
                Department
                </InputLabel>
                <TextField
              labelId="Department"
              id="outlined-multiline-static"
              multiline
              variant="outlined"
              placeholder="Enter Department Name"
              value={department}
              onChange={(e) => setdepartment(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
              />
            </>
          )}
            <button
              variant="contained"
              onClick={onSubmitform}
              style={{
                display: "inline-block",
                padding: "12px 24px",
                fontSize: "20px",
                fontWeight: "bold",
                cursor: "pointer",
                borderRadius: "20px",
                color: "#ffffff",
                backgroundColor: "#15D2F0",
                transition: "background-color 0.3s ease",
                outline: "none",
                overflow: "hidden"
              }}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              onMouseDown={handleMouseDown}
              onMouseUp={handleMouseUp}
            >
              SUBMIT
            </button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};


export default UserForm;